import type { Conversation, Message } from '@/features/AIChat/types/chat';
import isHumanMessage from '@/features/AIChat/utils/isHumanMessage';
import type { useAppDispatch } from '@/hooks/redux-hooks';
import type { UserConfig } from '@/slices/userConfigSlice';
import { saveUserConfig } from '@/slices/userConfigSlice';

const MAX_HISTORY = 10;

export const deriveConversationName = (messages: Message[]) => {
  const firstHuman = messages.find(m => isHumanMessage(m)) as
    | (Message & { sender: 'human'; text: string })
    | undefined;
  const text = (firstHuman?.text || '').trim();
  if (!text) return '...';
  return text;
};

interface SaveUserHistoryParams {
  userConfig: UserConfig;
  dispatch: ReturnType<typeof useAppDispatch>;
  updatedConversation: Conversation;
  existing: Conversation[];
  idx: number;
}

export default function saveUserHistory({
  userConfig,
  dispatch,
  updatedConversation,
  existing,
  idx
}: SaveUserHistoryParams) {
  const ensuredName =
    updatedConversation.name || deriveConversationName(updatedConversation.messages);

  const withName: Conversation = { ...updatedConversation, name: ensuredName };

  const chatHistory =
    idx >= 0
      ? [...existing.slice(0, idx), withName, ...existing.slice(idx + 1)]
      : [withName, ...existing];
  const limited = chatHistory.slice(0, MAX_HISTORY);
  dispatch(
    saveUserConfig({
      userConfig: {
        ...userConfig,
        chatHistory: limited
      }
    })
  );
}
